
















import { NtrFilter, NTR_FILTER_KEYS } from 'gl-ms-notifier';
import GenericFilter from '@/components/notifier/genericFilter.vue';
import {
    ACTION_GET_NOTIFIER_FILTER, ACTION_SET_NOTIFIER_FILTER, ACTION_TOGGLE_NOTIFIER_FILTERS, GET_ALL_NOTIFICATIONS,
} from '@/store/modules/notifier';
import notifierUtility from '@/services/notifier';
import { ACTION_GET_OFFICE_USERS, OfficeUser } from '@/store/modules/generic';

export default {
    data() {
        return {
            filterType: NTR_FILTER_KEYS,
        };
    },
    computed: {
        isMoreFilterOpen(this: any) {
            return this.$store.getters.notifierMoreFilter;
        },
        availableFilters(this: any) {
            return this.$store.state.notifier.filters;
        },
    },
    methods: {
        toggleMoreFilters(this: any) {
            this.$store.commit(ACTION_TOGGLE_NOTIFIER_FILTERS);
        },
        getFilter(this: any, key: string) {
            return this.$store.getters.getNotifierFilter(key);
        },
        enterButtonPressed(this: any) {

        },
    },
    components: {
        GenericFilter,
    },
    async mounted(this: any) {
        await this.$store.dispatch(ACTION_GET_OFFICE_USERS);
        await this.$store.dispatch(ACTION_GET_NOTIFIER_FILTER);
        const loggedUser = notifierUtility.currentUserInfo();
        const userFilter = this.availableFilters.find((q: NtrFilter) => q.key == NTR_FILTER_KEYS.USERS);
        if (userFilter && loggedUser) {
            const items = [{ label: loggedUser.name, value: loggedUser.email }];
            this.$store.commit(ACTION_SET_NOTIFIER_FILTER, { key: userFilter.key, values: items });
            this.$store.dispatch(GET_ALL_NOTIFICATIONS, true);
        }
    },
};
